import { Link } from 'react-router-dom';
import Search from "./search";
import "./header.css";

function HeaderSection() {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="site-header__brand" aria-label="ClimbingWeather.com home">
          <span className="site-header__logo">
            <img src="/img/icon_bare.png" alt="" width="28" height="28" />
          </span>
          <span className="site-header__wordmark">ClimbingWeather</span>
        </Link>
        <div className="site-header__search">
          <Search />
        </div>
        <nav className="site-header__nav" aria-label="Primary">
          <Link to="/forecast-by-state" className="site-header__nav-link">Browse areas</Link>
        </nav>
      </div>
    </header>
  );
}

export default HeaderSection;
